// Multiple Line Chart Hook
 import  {useMemo, useRef } from 'react'
import { StreamQualityChart } from '../classes/StreamQualityChart'


 /* Hook returns:
     - Reference for the rendered plot
     - Object of type ChartClass
 */
 export const StreamQualityChartHook = ({parameters}) =>
 {
     
    const objectReference = useRef()
    const initialParameters = useRef(parameters)
    const chart = useMemo(() => new StreamQualityChart(initialParameters.current, objectReference),[])    
 
    return([objectReference, chart])
 
 }

